export enum StatsScope {
  Match = 'match',
  Game = 'game',
}
